import React from 'react';
import PropTypes from 'prop-types';
import ContactForm from './components/ContactForm';
import Container from '../components/Container';

import './Contact.scss';

// Helpers
import * as helpers from '../../helpers';

function Contact({ id, ...props }) {
  const onSubmitFunc = (data, cb) => {
    helpers.sendEmail(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      data,
      process.env.REACT_APP_EMAILJS_USER_ID,
      cb
    );
  };

  const Description = () => (
    <p className="description">
      I am available for full time, part time and freelance work. Connect with
      me and let's talk about everything via this form or email:&nbsp;
      <b>dicksonpal_021@yahoo.com.ph</b>
    </p>
  );

  return (
    <section id={`${id}-section`} {...props}>
      <Container
        id={id}
        title="HIRE ME"
        titleClassName="underline fw-bold"
        description={<Description />}
        headerClassName="mb-5"
        className="mb-5 mb-sm-200"
      >
        <div className="col-12 col-md-6 mx-auto">
          <ContactForm onSubmitText="Send Message" onSubmit={onSubmitFunc} />
        </div>
      </Container>
    </section>
  );
}

Contact.defaultProps = {
  id: 'contact',
};

Contact.propTypes = {
  id: PropTypes.string,
};

export default React.memo(Contact, (prev, next) => true);
